import { createSocketClient } from '@/shared/lib/socket/SharedWorkerClient';

const UPBIT_WS_URL = 'wss://api.upbit.com/websocket/v1';

/**
 * Upbit WebSocket 구독 메시지 생성.
 * Upbit 형식: [{ ticket: '...' }, { type: 'ticker', codes: [...] }]
 */
const buildUpbitSubscribeMessage = (type: string, codes: string[]) => [
  { ticket: 'upbit-ws' },
  { type, codes },
];

export const upbitSocketManager = createSocketClient({
  exchange: 'upbit',
  url: UPBIT_WS_URL,
  buildSubscribeMessage: buildUpbitSubscribeMessage,
});
